<template>
  <div
    id="app"
    class="app">
    <asd20-app-header
      title="Our Schools"
      icon="school"
      :version="`${version}`"
    >
    </asd20-app-header>

    <keep-alive include="SchoolsPage">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { version } from '../package.json';
import Asd20AppHeader from '@asd20/ui/src/components/organisms/Asd20AppHeader'

export default {
  name: 'App',
  components: { Asd20AppHeader },
  data: () => ({
    version,
  }),
  mounted () {
    // Shortcut key to allow user to open School Info editor
    if (document) {
      window.APP_VERSION = version
      document.onkeyup = function(e) {
        if (e.ctrlKey && e.which == 69) {
          window.open("https://asd20-school-info.azurewebsites.net", "_blank")
        }
      }
    }
  }
}
</script>

<style lang="scss">
// @import '@asd20/ui/src/design/tokens.css';
@import '@asd20/ui/src/design/_variables.scss';
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_typography.scss';
@import '@asd20/ui/src/design/_template.scss';
@import '@asd20/ui/src/design/_print.scss';
@import '../node_modules/@asd20/ui/src/design/tokens.css';

.app {
  @include typography;
  @include template;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
    .asd20-district-logo {
    margin-right: space(0.5);
  }
  .asd20-icon {
    fill: #95b8eb;
  }
  .asd20-page-header__title-content h1 {
    color: var(--website-header__title-color);
  }
}

@media (min-width: 1024px) {
  #app .asd20-district-logo {
    margin-right: space(1);
  }
}
</style>
